export enum MessageAuthor {
  ME = 'me',
  GOALMATE = 'goalmate',
}

export const MESSAGES_PER_PAGE = 8;
export const CONTENT_MESSAGES_PER_PAGE = 8;
